import { createContext } from 'react';
export const CartLineContext = createContext(null);
